import React, { Fragment } from "react";
import { NumberInput } from "react-admin";

const BasketballTeamStats = ({ className, side }) => {
  const s = (key) => `${side}.basketball.${key}`;
  return (
    <Fragment>
      <NumberInput
        label="Total Points"
        source={s("totalPoints")}
        className={className}
      />
      <NumberInput
        label="First Quarter Points"
        source={s("firstQuarterPoints")}
        className={className}
      />
      <NumberInput
        label="Second Quarter Points"
        source={s("secondQuarterPoints")}
        className={className}
      />
      <NumberInput
        label="Third Quarter Points"
        source={s("thirdQuarterPoints")}
        className={className}
      />
      <NumberInput
        label="Fourth Quarter Points"
        source={s("fourthQuarterPoints")}
        className={className}
      />
      <NumberInput
        label="Overtime Points"
        source={s("overtimePoints")}
        className={className}
      />
      <NumberInput
        label="Overtime 2 Points"
        source={s("overtime2Points")}
        className={className}
      />
      <NumberInput
        label="Overtime 3 Points"
        source={s("overtime3Points")}
        className={className}
      />
    </Fragment>
  );
};

export default BasketballTeamStats;
